/**
 * Decodes JWT token and extracts user ID
 * @returns User ID from JWT token or null if not available
 */
export const getCurrentUserId = (): string | null => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.userId || payload.sub || null;
  } catch (error) {
    console.error('Failed to decode JWT token:', error);
    return null;
  }
};

/**
 * Decodes JWT token and returns the full payload
 * @returns JWT payload or null if decoding fails
 */
export const getTokenPayload = (): Record<string, any> | null => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    console.error('Failed to decode JWT token:', error);
    return null;
  }
};
